<script setup>
const modelValue = defineModel('modelValue');

/**
 * Wrapper for EnSpinner.
 */
const props = defineProps({
  /**
   * Whether the spinner is an overlay (true) or not (false).
   */
  overlay: Boolean,
});
</script>

<template>
  <template v-if="overlay">
    <div v-if="modelValue" class="en-overlay">
      <div class="en-overlay-spinner-card">
        <div class="flex flex-wrap flex-auto justify-center p-3 en-overlay-spinner-content">
          <slot></slot>
        </div>
      </div>
    </div>
  </template>
  <template v-else>
    <slot></slot>
  </template>
</template>

<style lang="scss" scoped>
@use "Styles/helper/variables";

.en-overlay {
  position: fixed;
  inset: 0;
  z-index: 2400;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgb(0 0 0 / 0.32);
}

.en-overlay-spinner-card {
  width: 200px;
  border-radius: 0.375rem;
  background-color: variables.$en-red !important;
  color: variables.$en-0 !important;
}

.en-overlay-spinner-content {
  color: variables.$en-0 !important;
}
</style>
